// extracted by mini-css-extract-plugin
export var root = "PlasmicControlButton-module--root--ePmKD";
export var slotTargetIcon = "PlasmicControlButton-module--slotTargetIcon--Qzqnk";
export var __wab_slot = "PlasmicControlButton-module--__wab_slot--qL5L8";
export var svg__gq6W7 = "PlasmicControlButton-module--svg__gq6W7--4B6Ip";